<template>
  <el-container>
    <el-dialog :visible="detailVisible" @opened="openUser" :before-close="handleClose" append-to-body
               :wrapperClosable="false" :close-on-click-modal="false">
      <el-row style="padding: 30px">
        <el-col :span="24" style="font-size: 20px ;text-align:center">
          <span>{{form.noticeName}}</span>
        </el-col>
        <span >信息简介:</span>
<!--        <span style="float: right;margin-right:5px;">发布日期 {{form.publishDate}}</span>-->
        <el-col :span="24" style="font-size: 15px ;text-align:center">
          <span>{{form.detail}}</span>
        </el-col>
        <el-col :span="24">
          <p v-html="form.productDetail"/>
        </el-col>
      </el-row>
      <el-row class="drawer_footer">
        <el-button type="primary" @click="copyLink()" size="medium" :disabled="$store.state.loading">复制链接地址</el-button>
      </el-row>
    </el-dialog>
  </el-container>
</template>

<script>
export default {
  name: "ProductDetail",
  props: ['selRow', 'detailVisible'],
  data() {
    return {
      form: {},
    }
  },
  methods: {
    copyLink() { // 复制链接
      let url = "http://www.ddjtaqkh.com/#/web/webApproveDetail?id="+this.form.id; // 后台接口返回的链接地址
      let inputNode = document.createElement('input');  // 创建input
      inputNode.value = url; // 赋值给 input 值
      document.body.appendChild(inputNode); // 插入进去
      inputNode.select(); // 选择对象
      document.execCommand('Copy'); // 原生调用执行浏览器复制命令
      inputNode.className = 'oInput';
      inputNode.style.display = 'none'; // 隐藏
      this.$message.success('复制成功');
      this.handleClose();
    },
    openUser() {
      this.form = {...this.selRow};
      //this.form.detail = `作者：${this.form.noticeAuthor}发布日期：${this.form.publishDate}`;
    },
    //下边是弹出
    handleClose() {
      this.$emit('update:detailVisible', false)
    }
  },
}
</script>

<style scoped>

</style>